import { baseService } from 'modules/baseService';
import { ExternalSubmission, GetSubmissionArgs } from './typings';
import HttpClient from 'services/HttpClient'

export const getSubmission = baseService<GetSubmissionArgs, ExternalSubmission>(
  ({ id, token }) =>
    HttpClient.get('posts/' + id, {
      headers: { authorization: `Bearer ${token}` },
    }),
);
